module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av275-ba31c54b8c49b89b814e61a867871a41.jpg";